<template>
    <el-dialog 
        :visible="openDialog"
        :close-on-click-modal="false"
        title="Import from Proposal"
        append-to-body
        @close="closeDialog">

        <el-row class="mt-10">
            <el-col :span="24">
                <proposal-search
                    @selected="proposal_id = $event"
                ></proposal-search>
            </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
            <el-button 
                :disabled="processing" 
                @click="closeDialog"
            >
                Close
            </el-button>
            <el-button 
                :disabled="processing || ! proposal_id"
                @click="process"
                type="success"
            >
                <i v-if="processing" class="fa fa-pulse fa-spinner"></i> Add hiring area
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import ProposalSearch from '../../../clients/Proposals/vue/proposal-search.vue';

export default {
    components: { 
        ProposalSearch
    },
    props: {
        openDialog: { type: Boolean, required: true },
        areaId: { type: Number, required: true },
    },
    data() {
        return {
            proposal_id: null,
            processing: false,
        };
    },
    methods: {
        process() {
            this.processing = true;
            this.errorMessage = null;

            axios.post(this.url(`admin/area/import-from-proposal`), {
                area_id: this.areaId,
                proposal_id: this.proposal_id,
            })
            .then(response => {
                this.closeDialog();
                this.$emit('process');
            })
            .finally(() => { this.processing = false; });
        },
        closeDialog() {
            this.$emit('update:openDialog', false);
        },
    },
};
</script>

<style scoped>
.mt-10 {
    margin-top: 10px;
}
</style>